import React, { useEffect, Fragment, useState } from "react";
import { Progress } from "antd";

import Backgrounds from "../../_partials/Backgrounds/Index";
import TemplateBlock from "../../_partials/TemplateBlock/Index";
import prepareVideoBg from "../../../../shared/functions/prepareVideoBg";
import animationScript, { animationCleanUp } from "./animation";

import assets from "./assets";

import "./style/style.scss";
import "./style/animation.scss";
import getContentById from "../../../../shared/utils/getContentById";
import parseMediaUrl from "../../../../shared/functions/parseMediaUrl";
import ImageOrVideo from "../../../../shared/components/ImageOrVideo/Index";
import TeamLogo from "../../_partials/TeamLogo";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import { getScaleSize } from "../Lineup/Index";
import { ratioFromFormat } from "../ResultsNew/Index";
import Functions from "../../../../shared/components/MediaLibrary/EditModal/functions";
import { PresetColors } from "../../../../shared/components/MediaLibrary/EditModal/LeftSidebar/EditTab";
import { getImageFilterStyle, getWrapperDimensions } from "../../../../shared/components/MediaLibrary/EditModal/ImageEditorModal";
import { DEFAULT_ADJUSTMENTS } from "../../../constants/constants";

const getMainBackground = () => {
  return _.get(assets, `mainbackground`);
};

const getBlueBg = () => {
  return assets.bg_blue;
};

const Index = ({ animation, data, mode, format, prevRatio, _searchParams, ...props }) => {
  const templateName = data?.template_name ?? "";
  const id = `${templateName}_${data?.uuid}`;

  const backgroundImage = getMainBackground();
  const blueBg = getBlueBg();

  const { t } = useTranslation();


  const selectedLang = data?.lang;

  const prepareAnimation = () => {
    prepareVideoBg({ id });
  };

  useEffect(() => {
    let animationReturn = null;
    if (mode === "animation" || mode === "video") {
      if (animation) {
        prepareAnimation();
        animationReturn = animationScript({
          id,
          data,
          format,
          apiSetup: props?.apiSetup,
          templateName: data?.template_name,
        });
      }
    }

    if (mode === "screenshot") {
      const videoBg = $(`#${id} video.custom-background`).get(0);
      if (videoBg) {
        videoBg.addEventListener(
          "loadedmetadata",
          function () {
            this.currentTime = 3;
            this.pause();
          },
          false,
        );
      }
    }

    return function cleanUp() {
      if (animationReturn) {
        animationCleanUp(animationReturn);
      }
    };
  }, [animation, mode]);

  const { options, fields, dynamic, editData } = data.data || {};

  const {
    last10Matches,
    timezones,
  } = data?.data?.dynamic;

  const homeTeam = data?.event?.home;
  const awayTeam = data?.event?.away;
  let statsLeftTeam = homeTeam;
  let statsRightTeam = awayTeam;
  if (statsRightTeam.shortcut == 'FCB') {
    statsLeftTeam = awayTeam;
    statsRightTeam = homeTeam;
  }

  const competitionId = data?.event?.competitionId;

  const date = data?.event?.date;
  const time = data?.event?.time;
  const [day, month, year] = date.split(".");
  const dateTimeString = `${year}-${month}-${day}T${time}`;
  const basetime = new Date(dateTimeString);
  const quoteText = getContentById("quote", fields);
  const author = getContentById("author", fields);
  const selectedMedia1 = getContentById("media1", fields);
  const selectedMedia2 = getContentById("media2", fields);

  const [layers, setLayers] = useState([]);
  const defaultEffects = {
    isBlur: false,
    isOpacity: false,
    isGradient: false,
    isShadow: false,
    resize: 100,
    ratio: 0,
    ratioUrl: "",
    prevRatio: 0,
    jersey: PresetColors.white,
  }
  const [effects, setEffects] = useState(defaultEffects);


  useEffect(() => {
    const initialLayers = editData?.layers;
    const initialEffects = editData?.effects;

    if (initialLayers) {
      setTimeout(() => {
        setLayers(initialLayers);
        setEffects(initialEffects ?? defaultEffects);
        if (initialEffects?.ratio > 0) {
          // prevRatioRef.current = initialEffects?.ratio;
        }
      }, 500);
    }
    if (!initialLayers && !editData) {
      const getBackgroundUrls = () => {
        const background = getContentById("background", fields, "self");
        const values = background?.value;
        if (!Array.isArray(values)) return [];

        return values.map((val) => parseMediaUrl(_.get(val, "url", "")));
      }
      const backgroundUrls = getBackgroundUrls();
      const initializeLayers = async () => {
        const newLayerPromises = backgroundUrls.map(async (url, index) => {
          const functions = new Functions(url);
          const finalUrl = functions.getUrl();
          const newDimension = getWrapperDimensions(effects.ratio);
          const newLayer = {
            id: Date.now() + index,
            imageUrl: finalUrl,
            backgroundUrl: url,
            functions,
            dimensions: { width: newDimension.width, height: newDimension.height },
            originalDimensions: { width: newDimension.width, height: newDimension.height },
            nonRatioDimensions: { width: newDimension.width, height: newDimension.height },
            adjustments: { ...DEFAULT_ADJUSTMENTS },
            x: 0,
            y: 0,
            nonRatioX: 0,
            nonRatioY: 0,
            zIndex: index + 1,
            backgroundAndResize: {
              removebg: false,
              removebgUrl: "",
              changebg: false,
              changebgUrl: ""
            },
            isResizing: false,
            isRecreated: false,
          };

          return newLayer;
        });

        const addedLayers = await Promise.all(newLayerPromises);

        setLayers(addedLayers);
        // prevRatioRef.current = 0.56; //default
        setEffects(defaultEffects)
      }
      initializeLayers();
    }
  }, [editData, fields])

  const [ratioSize, setRatioSize] = useState({
    width: 4.075,
    height: 4.075
  });

  useEffect(() => {
    if (prevRatio) {
      setRatioSize(getScaleSize(format, prevRatio));
    } else {
      const editData = data?.data?.editData;
      if (editData) {
        setRatioSize(getScaleSize(format, ratioFromFormat(data.currentFormat)));
      } else {
        setRatioSize(getScaleSize(format, 0));
      }
    }
  }, [format, prevRatio])
  const customBackground = getContentById("background", fields, "self");
  const customBackgroundStyles = _.get(
    customBackground,
    `styles.${format}`,
    {},
  );
  return (
    <div
      id={id}
      className={`T_${templateName} ${animation ? "animation" : ""}`}
    >
      <TemplateBlock>
        <div className={`wc-content content`}>
          <div className={"media1-container"}>
            <div className={"custom-background-container"}>
              <div
                id={_.get(customBackground, "id", null)}
                style={customBackgroundStyles}
                className={"custom-background"}
              >
                {layers
                  .map((layer, index) => {
                    const { id, adjustments, imageUrl, dimensions, x, y } = layer;
                    const filterStyles = getImageFilterStyle(adjustments);
                    const { colorOverlays = [], ...filterStyle } = filterStyles;
                    return (
                      <div
                        style={{
                          position: 'absolute',
                          width: `${dimensions.width * ratioSize.width}px`,
                          height: `${dimensions.height * ratioSize.height}px`,
                          left: `${x * ratioSize.width}px`,
                          top: `${y * ratioSize.height}px`,
                          ...filterStyle
                        }}
                        key={id}
                      >
                        <img
                          src={imageUrl}
                          style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover'
                          }}
                        />
                        <div
                          style={{
                            position: "absolute",
                            bottom: 0,
                            left: 0,
                            right: 0,
                            height: "65%", // Adjust as needed
                            background: "linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(20, 20, 20, 0.7) 40%, rgba(30,30,30,1) 100%)",
                            pointerEvents: "none",
                            zIndex: 2,
                          }}
                        />
                        {/* Color overlays */}
                        {colorOverlays.map((overlayStyle, i) => (
                          <div
                            key={i}
                            style={{
                              position: 'absolute',
                              top: 0,
                              left: 0,
                              width: '100%',
                              height: '100%',
                              pointerEvents: 'none',
                              ...overlayStyle
                            }}
                          />
                        ))}
                      </div>
                    );
                  })}
              </div>
            </div>
            <div className="match-results-container">
              <div className="match-results-left-container">
                {
                  last10Matches?.slice(0, 5).map((item) => {
                    const { matchInfo, liveData: { matchDetails } } = item;
                    const _homeTeam = matchInfo?.contestant?.[0];
                    const _awayTeam = matchInfo?.contestant?.[1];
                    const score = matchDetails?.scores?.total;
                    let homeScore = score?.home ?? 0;
                    let awayScore = score?.away ?? 0;
                    const date = matchInfo?.date?.replace('Z', '');
                    return (
                      <div className="result-item">
                        <div className="home-team-logo-container">
                          <TeamLogo team={_homeTeam} competitionId={competitionId} />
                        </div>
                        <div className="item-score-container">
                          <div className="item-score-date">
                            {date}
                          </div>
                          <div className="item-score-value">
                            {homeScore} - {awayScore}
                          </div>
                        </div>
                        <div className="away-team-logo-container">
                          <TeamLogo team={_awayTeam} competitionId={competitionId} />
                        </div>
                      </div>
                    )
                  })
                }
              </div>

              <div className="match-results-right-container">
                {
                  last10Matches?.slice(5).map((item) => {
                    if (!item) return <></>;
                    const { matchInfo, liveData: { matchDetails } } = item;
                    const _homeTeam = matchInfo?.contestant?.[0];
                    const _awayTeam = matchInfo?.contestant?.[1];
                    const score = matchDetails?.scores?.total;
                    let homeScore = score?.home ?? 0;
                    let awayScore = score?.away ?? 0;
                    const date = matchInfo?.date?.replace('Z', '');
                    return (
                      <div className="result-item">
                        <div className="home-team-logo-container">
                          <TeamLogo team={_homeTeam} competitionId={competitionId} />
                        </div>
                        <div className="item-score-container">
                          <div className="item-score-date">
                            {date}
                          </div>
                          <div className="item-score-value">
                            {homeScore} - {awayScore}
                          </div>
                        </div>
                        <div className="away-team-logo-container">
                          <TeamLogo team={_awayTeam} competitionId={competitionId} />
                        </div>
                      </div>
                    )
                  })
                }
              </div>
            </div>
          </div>
        </div>
        <div className="gradient-left"></div>
        <div className="gradient-right"></div>
      </TemplateBlock>
    </div>
  );
};

export default Index;
